let data2 = [
    {
        id: 0,
        contents:"Organic Fruits",
        title: "Banana - Raw, Organically Grown",
        imgUrl: "img/main1.jpg",
        price:"$180.00",
        demo:"e"
    },
    {
        id: 1,
        contents:"Winter Veggies",
        title: "Chilli - Green, Organically Grown",
        imgUrl: "img/main2.jpg",
        price:"$391.00",
        demo:"h"
    },
    {
        id: 2,
        contents:"Organic Fruits",
        title: "Healthy Vegetables - Organical...",
        imgUrl: "img/main3.jpg",
        price:"$392.00",
        demo:"c"

    },
    {
        id : 3,
        contents:"Winter Veggies",
        title: "Fruit - Fresh, Regular, 2 Pcs, Only our..",
        imgUrl: "img/main4.jpg",
        price:"$1,850.00",
        demo:"g"
      },
    {
      id : 4,
      contents:"Summer Fruits",
      title: "Pomegranate - Small (Quick delivery)",
      imgUrl: "img/main5.jpg",
      price:"$280.00",
      demo:"b"
    },
    {
      id : 5,
      contents:"Winter Veggies",
      title: "R Chilli - Green, Organically Grown",
      imgUrl: "img/main6.jpg",
      price:"$393.00",
      demo:"d"
    },
    {
      id : 6,
      contents:"Winter Veggies",
      title: "D Chilli - Green, Organically Grown",
      imgUrl: "img/main7.jpg",
      price:"$390.00",
      demo:"a"
    },
    {
      id : 7,
      contents:"Vagetables",
      title: "Red Onion - Organically Grown (Best)",
      imgUrl: "img/main8.jpg",
      price:"$890.00",
      demo:"f"
    }
]

export default data2;